import { TableCell } from '@material-ui/core';
import React from 'react';
import useCellStyles from './Header.styles';

const ActionsCell = () => {
  const cellClasses = useCellStyles();

  return <TableCell classes={cellClasses} />;
};

export default ActionsCell;
